export var SoundsMode;
(function (SoundsMode) {
    SoundsMode["ALL"] = "ALL";
    SoundsMode["IMPORTANT"] = "IMPORTANT";
    SoundsMode["NONE"] = "NONE";
})(SoundsMode || (SoundsMode = {}));
export var SoundPlayerState;
(function (SoundPlayerState) {
    SoundPlayerState["INITIAL"] = "INITIAL";
    SoundPlayerState["PRELOADING"] = "PRELOADING";
    SoundPlayerState["PRELOADED"] = "PRELOADED";
})(SoundPlayerState || (SoundPlayerState = {}));
